import React from 'react'
import {connect} from 'react-redux'
import {getCreateOrderBody, getError, getOrder, isOrderLoading} from './OrderReducers';
import {create, changeForm, openSubform, skip, saveFormValues, resetForm, saveOrderRequestData} from './OrderActions';
import PropTypes from 'prop-types'
import OrderForm from './OrderForm';
import {select, finish} from '../steps/StepsActions';
import {STEP_CONFIGURE_WIDGET, STEP_SETUP_ENVIRONMENT} from '../steps/StepsContants';
import {getAppMode} from '../app/AppReducers';
import {TRANSACTION_TYPES} from './OrderConstants';
import {formValueSelector} from 'redux-form';
import {AuthorizationUtils} from '../utils/AuthorizationUtils';
import './Order.css';
import {
  SUBFORM_BILLING_ADDRESS,
  SUBFORM_CUSTOMER,
  SUBFORM_PERSONA,
  SUBFORM_SHIPPING_ADDRESS
} from "./subforms/SubformsConstants";
import RequestTemplate from "../common/RequestTemplate";
import {TAB_BUTTON_WIDGET} from '../tabs/TabsConstants';
import {FormUtils} from "../utils/FormUtils";

const OrderContainer = ({order, state, error, create, skip, saveFormValues, config, loading, select, finish, mode, openSubform, resetForm, saveOrderRequestData}) => {

  const onSubmitHandler = () => {
    saveFormValues(getRawFormValues());

    if (state.tabs.selected === TAB_BUTTON_WIDGET) {
      saveOrderRequestData(getOrderRequestBody(), finish);
    } else {
      create(getOrderRequestBody(), config, finish);
    }
  };

  const previous = () => {
    saveFormValues(getRawFormValues());
    select(STEP_SETUP_ENVIRONMENT);
  };

  const onCreateCustomer = () => {
    saveFormValues(getRawFormValues());
    openSubform(SUBFORM_CUSTOMER);
  };

  const onCreatePersona = () => {
    saveFormValues(getRawFormValues());
    openSubform(SUBFORM_PERSONA);
  };

  const onCreateBillingAddress = () => {
    saveFormValues(getRawFormValues());
    openSubform(SUBFORM_BILLING_ADDRESS);
  };

  const onCreateShippingAddress = () => {
    saveFormValues(getRawFormValues());
    openSubform(SUBFORM_SHIPPING_ADDRESS);
  };

  const onSkip = () => {
    saveFormValues(getRawFormValues());
    skip();
    finish();
    select(STEP_CONFIGURE_WIDGET);
  };

  const onReset = () => {
    resetForm();
  };

  const getOrderResponse = () => {
    if (order) {
      return <div>
        <h3>Response</h3>
        <pre>{JSON.stringify(order, null, 2)}</pre>
      </div>
    }
    if (error) {
      return <div>
        <h3>Response</h3>
        <pre>{JSON.stringify(error, null, 2)}</pre>
      </div>
    }
    return '';
  };

  const getRawFormValues = () => {
    const selector = formValueSelector('order');

    const formValues = selector(
      state, 'amount', 'currency', 'transactionType', 'addBasket', 'addCustomer', 'customer', 'addPersona', 'persona',
      'billingAddress', 'addBillingAddress', 'shippingAddress', 'addShippingAddress', 'async', 'allowedProducts', 'ipAddress'
    );

    return FormUtils.getNotEmptyValues(formValues);
  };

  const getOrderRequestBody = () => {
    const formValues = getRawFormValues();
    const selector = formValueSelector('order');
    if (selector(state, 'allowedProducts')) {
      formValues.allowedProducts = selector(state, 'allowedProducts').replace(/ /g,'').split(',');
    } else {
      delete formValues.allowedProducts;
    }

    const asyncObject = FormUtils.getValuesByUsage(selector(state, 'paymentDetailsUsage'), selector(state, 'async'));

    formValues.async = FormUtils.getNotEmptyValues(asyncObject);

    return FormUtils.getNotEmptyValues(formValues);

  };

  const getOrderRequest = () => {
    const formValues = getOrderRequestBody();

    return <RequestTemplate httpMethod={'POST'} url={`${config.api.baseUrl}/orders`}
                            authorizationHeader={AuthorizationUtils.base64(config.environment.merchantId, config.environment.apiKey)}
                            body={getCreateOrderBody(formValues)}/>
  };

  const loadingContent = loading ? 'Loading ...' : '';

  const getForm = () => {
    return <OrderForm
      customReset={onReset}
      mode={mode}
      onSubmit={onSubmitHandler}
      onPrevious={previous}
      onCreateCustomer={onCreateCustomer}
      onCreatePersona={onCreatePersona}
      onCreateBillingAddress={onCreateBillingAddress}
      onCreateShippingAddress={onCreateShippingAddress}
      transactionTypes={TRANSACTION_TYPES}
      skip={onSkip}
    />
  };

  return (
    <div>
      <div className="col-lg-6 col-md-12 col-xs-12">
        <div>{loadingContent}</div>
        {getForm()}
      </div>
      <div className="col-lg-6 col-md-12 col-xs-12">
        {getOrderRequest()}
        {getOrderResponse()}
      </div>
    </div>
  );
};

OrderContainer.propTypes = {
  create: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  order: getOrder(state),
  state: state,
  error: getError(state),
  loading: isOrderLoading(state),
  config: state.app.config,
  mode: getAppMode(state)
});

export default connect(
  mapStateToProps,
  {create, skip, saveFormValues, select, finish, changeForm, openSubform, resetForm, saveOrderRequestData}
)(OrderContainer);



// WEBPACK FOOTER //
// ./src/order/OrderContainer.js